import {createFileRoute} from "@tanstack/react-router";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {getProductById} from "~/domainModels/ottokart/products";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/ottokart/_ottokartScaffold/admin/products/edit/$productId",
)({
    loader: async ({context, params}) => {
        const productIdResult = uuidZodValidator.safeParse(params.productId);
        if (!productIdResult.success) {
            throw new Error("Invalid product ID");
        }
        const productResult = await getProductById({
            accessToken: context.authenticationStatus.accessToken,
            intellsysBaseUrl: context.intellsysBaseUrl,
            productId: productIdResult.data,
            workspaceId: context.workspace.id,
        });
        if (productResult.success !== true) {
            throw productResult.error;
        }
        return {
            product: productResult.data,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
